<template>
  <button
    class="hotel-list-card"
    :disabled="isLoading"
    @click="hotelSelected(item)"
  >
    <span
      class="hotel-name"
      v-html="parsedPropertyName ? parsedPropertyName : item.propertyName"
    />
    <span
      class="country-name"
      v-html="parsedCountry ? parsedCountry : item.country"
    />
    <span
      v-if="isSelecting"
      class="icon-loading-black"
    />
  </button>
</template>

<script>
  import { highlightMatch } from '@utils/highlight-match'

  export default {
    name: 'HotelListCard',
    props: {
      item: {
        type: Object,
      },
      searchInput: {
        type: String,
        default: ''
      },
      queryChanged: {
        type: Number,
        default: -1
      },
      isLoading: Boolean
    },
    data: () => ({
      searchString: '',
      isSelecting: false
    }),
    computed: {
      parsedPropertyName: {
        get() {
          return highlightMatch(this.searchString, this.item.propertyName, 'bold-highlighted')
        },
        set(newValue) {
          this.searchString = newValue
        }
      },
      parsedCountry: {
        get() {
          return highlightMatch(this.searchString, this.item.country, 'bold-highlighted')
        },
        set(newValue) {
          this.searchString = newValue
        }
      },
    },
    watch: {
      searchInput(val) {
        if (val) {
          this.searchString = val
        } else {
          this.searchString = ''
        }
      },
      queryChanged() {
        this.searchString = this.searchInput
      }
    },
    methods: {
      hotelSelected(item) {
        this.isSelecting = true
        this.$emit('hotel-selected', item)
      }
    }
  }
</script>
